import { reactive } from "vue";
import { Buffer } from "buffer";
import LoginService from "@/services/LoginService";
import CurrentUser from "../models/CurrentUser";

export const store = reactive({
  currentUser: new CurrentUser(),
  authentication: {
    username: null,
    password: null,
  },
  token: null,
  destination: "/",
  loading: false,
  errorLogin: false,

  login() {
    let username = this.authentication.username;
    let password = this.authentication.password;
    this.token =
      "Basic " +
      Buffer.from(username + ":" + password, "utf8").toString("base64");
    return LoginService.logIn(this.token)
      .then(
        ({ data }) => {
          console.debug(data);
          if (data == null) this.token = null;

          const { name, company, provider, roles, userId } = data;
          const now = new Date();
          let currentUser = new CurrentUser(
            this.token != null,
            now.getTime() + 86400000,
            userId,
            name,
            company,
            roles,
            provider
          );
          
          localStorage.setItem("user", JSON.stringify(currentUser));
          localStorage.setItem("token", this.token);
          if (this.destination == null || this.destination == "/") {
            this.destination = "/monitoring-map";
          }
          this.currentUser = currentUser;
          return Promise.resolve(currentUser);
        },
        (error) => {
          this.logout();
          console.debug(error);
          // window.alert("Login failed");
          this.errorLogin=true;
          setTimeout(() => {this.errorLogin=false;}, 5000);
          return Promise.reject(new CurrentUser());
        }
      )
      .finally(() => (store.loading = false));
  },

  logout() {
    this.currentUser = new CurrentUser();
    this.token = null;
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.clear()
  },

  updateSession() {
    this.currentUser = this.getUser();
    this.token = localStorage.getItem("token");
    const now = new Date();
    //trying to understand the role of an expiraton in this context
    (this.currentUser.expiry = now.getTime() + 86400000),
      localStorage.setItem("user", JSON.stringify(this.currentUser));
  },

  isLoginEnabled() {
    let isEnabled =
      this.authentication != null &&
      this.authentication.username != null &&
      this.authentication.password != null &&
      !(this.authentication.password.trim().length === 0) &&
      !(this.authentication.username.trim().length === 0);
    return isEnabled;
  },
  getUser() {
    let user = localStorage.getItem("user");
    if (user) {
      let localuser = JSON.parse(user);
      //prevent oldmapping to create error at login
      if (localuser.user) {
        console.log("map fix system")
        let mapOld = new CurrentUser(
          localuser.isLoggedIn,
          localuser.expiry,
          //in the old version the id was not indicated
          null,
          localuser.user.username,
          localuser.user.company,
          localuser.user.roles,
          localuser.provider
        );
        localStorage.setItem("user", JSON.stringify(mapOld));
        this.currentUser = mapOld;
      } else {
        this.currentUser = localuser;
      }
    }
    return this.currentUser;
  },

  getToken() {
    let token = localStorage.getItem("token");
    if (token != undefined) {
      this.token = token;
    }
    console.debug("TOKEN got " + this.token);
    return this.token;
  },
  startLoading() {
    this.loading = true;
  },
  stopLoading() {
    this.loading = false;
  },
});
